var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-header'),_c('PageHeader',{attrs:{"title":"Server Status"}}),_c('div',{staticClass:"container py-10"},[_c('div',{staticClass:"login-container max-w-md mx-auto"},[_c('div',{staticClass:"rounded-lg bg-gray-100 p-10 Sample"},[_c('ServerInfo')],1)])]),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }